
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Heart, Anchor, Plane } from 'lucide-react';

const SanDiegoPage = () => {
  return (
    <CityPageTemplate
      city="San Diego"
      state="California"
      stateAbbr="CA"
      population="1.4 million+"
      majorIndustries={["biotechnology", "defense", "tourism", "healthcare", "manufacturing"]}
      businessChallenges={[
        "Defense contractor compliance requirements",
        "Biotech industry regulatory complexities",
        "Seasonal tourism workforce fluctuations",
        "Cross-border employment considerations",
        "Military spouse employment challenges"
      ]}
      peoSolutions={[
        "Defense contractor compliance expertise",
        "Biotech industry specialized HR services",
        "Seasonal workforce management solutions",
        "Professional benefits for military families",
        "Cross-border payroll and tax compliance"
      ]}
      localBusinessTypes={[
        { name: "Biotechnology", description: "Research, pharmaceuticals, medical devices" },
        { name: "Defense", description: "Contractors, aerospace, cybersecurity" },
        { name: "Tourism", description: "Hotels, restaurants, attractions" },
        { name: "Healthcare", description: "Hospitals, clinics, life sciences" }
      ]}
      metaDescription="Find the best PEOs in San Diego with The PEO App. Compare quotes from top San Diego Professional Employer Organizations offering specialized HR solutions for biotech, defense, and tourism businesses."
      keyFeatures={[
        {
          icon: Heart,
          title: "Biotech Industry Focus",
          description: "Specialized HR solutions for San Diego's life sciences sector with regulatory compliance and research facility support."
        },
        {
          icon: Anchor,
          title: "Defense Contractor Support",
          description: "Expert HR services for defense contractors including security clearance management and federal compliance."
        },
        {
          icon: Plane,
          title: "Tourism & Hospitality",
          description: "Seasonal workforce management and hospitality-specific HR solutions for San Diego's tourism industry."
        }
      ]}
    />
  );
};

export default SanDiegoPage;
